import React, { useState } from 'react';
import { Button, Checkbox, Form, Icon } from 'antd';
import Modal from '../../../components/Modal/Modal';
import TermsConditions from '../../../components/Login/components/TermsConditions';
import InfoBox from '../../../components/InfoBox/InfoBox';
import {
  REGISTRATION_TERMS_OPTIONS,
  validateRegistrationTerms,
} from '../../../constants/registrationTerms';
import { getOnboardingPathLabel } from '../onboardingLinkParams';
import { ORG_ONBOARDING_INFO_COLOR } from '../onboardingConstants';

const FormItem = Form.Item;
const CheckboxGroup = Checkbox.Group;

export default function ConfirmStep({ form, registration, isSubmitting, onBack, onComplete }) {
  const [allTermsAccepted, setAllTermsAccepted] = useState(false);
  const { getFieldDecorator } = form;
  const { account, organisation, plan } = registration;
  const key = (registration.activation && registration.activation.subscriptionKey) || '';
  const promo = (registration.activation && registration.activation.promoCode) || '';
  const activationSummary = getActivationSummary(key, promo);
  const pathLabel = getOnboardingPathLabel(registration.userType);

  return (
    <div className="onboarding-registration-panel-body">
      <div className="onboarding-registration-panel-main">
        <InfoBox
          className="onboarding-registration-panel-infobox"
          color={ORG_ONBOARDING_INFO_COLOR}
          honorSectionGuidanceToggle={false}
          message={
            <div>
              <p>
                <strong>Review your summary</strong>
              </p>
              <p>
                Confirm your details below look correct, accept the terms and conditions, then activate your account.
              </p>
            </div>
          }
        />

        <ul className="onboarding-registration-confirm-list">
          <li>
            <Icon type="user" />
            <span>
              <strong>Email</strong> {account.email || 'Not set'}
            </span>
          </li>
          {pathLabel && (
            <li>
              <Icon type="team" />
              <span>
                <strong>Registration type</strong> {pathLabel}
              </span>
            </li>
          )}
          <li>
            <Icon type="bank" />
            <span>
              <strong>Organisation</strong>{' '}
              {organisation.tradingName || organisation.businessName || 'Add later'}
            </span>
          </li>
          <li>
            <Icon type="file-text" />
            <span>
              <strong>Plan</strong> {plan.name || 'Not set'} ({plan.currency})
            </span>
          </li>
          <li>
            <Icon type="key" />
            <span>
              <strong>Activation</strong> {activationSummary}
            </span>
          </li>
        </ul>

        <div className="onboarding-registration-terms">
          <FormItem colon={false} className="onboarding-registration-terms-form-item">
            <Modal
              title="THE PROCESSING OF PERSONAL DATA: AGREEMENT"
              width="auto"
              wrapClassName="terms-conditions-modal"
              toggle={(show) => (
                <Button type="link" className="onboarding-registration-terms-link" onClick={show}>
                  Click here to read the AGREEMENT (GDPR)
                </Button>
              )}
            >
              {() => <TermsConditions />}
            </Modal>
            {getFieldDecorator('termsAgreement', {
              rules: [{ validator: validateRegistrationTerms }],
            })(
              <CheckboxGroup
                className="onboarding-registration-terms-checkboxes"
                options={REGISTRATION_TERMS_OPTIONS}
                onChange={(values) =>
                  setAllTermsAccepted(values.length >= REGISTRATION_TERMS_OPTIONS.length)
                }
              />,
            )}
          </FormItem>
        </div>
      </div>

      <div className="onboarding-registration-actions onboarding-registration-actions-between onboarding-registration-actions-bar">
        <Button htmlType="button" onClick={onBack} disabled={isSubmitting}>
          Back
        </Button>
        <Button
          type="primary"
          htmlType="button"
          loading={isSubmitting}
          disabled={!allTermsAccepted}
          onClick={onComplete}
        >
          <Icon type="check-circle" />
          Activate Account
        </Button>
      </div>
    </div>
  );
}

function getActivationSummary(subscriptionKey, promoCode) {
  const k = String(subscriptionKey || '').trim();
  if (k) return `Subscription key on file (${maskSecret(k)})`;
  const p = String(promoCode || '').trim();
  if (p) return `Promo code on file (${maskSecret(p)})`;
  return 'Subscription details on file';
}

function maskSecret(value) {
  const s = String(value).trim();
  if (!s) return '';
  if (s.length <= 8) return '...';
  return `${s.slice(0, 4)}...${s.slice(-4)}`;
}
